import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PreferredPartnerService } from '../../preferred-partner.service';
import { ProgramConfigResponse, RegionProgramConfig } from '../../types';

/**
 * /preferred-partner/rules
 *
 * Educational cards explaining the program. Carrier-side rules and the four
 * driver rules are static; the numeric thresholds (shift floor, load tiers,
 * evaluator version) are pulled live from `/program_config` so we never
 * surface stale numbers.
 */
@Component({
  selector: 'lohi-ppp-program-rules',
  templateUrl: './ppp-program-rules.component.html',
  styleUrls: ['./ppp-program-rules.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PppProgramRulesComponent implements OnInit, OnDestroy {
  public readonly programConfig$: Observable<ProgramConfigResponse | null>;

  private destroy$$ = new Subject<void>();

  constructor(private pppService: PreferredPartnerService) {
    this.programConfig$ = this.pppService.programConfig$;
  }

  public ngOnInit(): void {
    this.pppService.programConfig$.pipe(takeUntil(this.destroy$$)).subscribe();
  }

  public ngOnDestroy(): void {
    this.destroy$$.next();
    this.destroy$$.complete();
  }

  public trackByRegion(index: number, item: RegionProgramConfig): number {
    return item.regionId;
  }
}
